import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { SiteList, PubList } from '../FormComponents';
import { SiteEntry, GroupPubListEntry,upGroupPubListEntry, PubListEntry } from '../../services/interfaces';
import { getGroupPubList, deleteGroupPub, saveGroupPub } from '../../services/apiAdminService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';

interface PageState {
    skip: number;
    take: number;
}

//const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'groupName', dir: 'asc' },{ field: 'pubName', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20
};

interface editProps{
    groupPub:GroupPubListEntry,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewGroupPub
    {
        oName:string
        oPubNum:string
        name:string
        pubNum:string
        userType:string
        groupNum:string
        groupNumCode:string
        tmpChar:string
        tmpInt:number
    }


const EditDialog=(props:editProps)=>{

    const [newGroupPub, setNewGroupPub]= useState<NewGroupPub>(
        {
            oName:"",
            oPubNum:"",
            name:"",
            pubNum:"",  
            userType:"",
            groupNum:"",
            groupNumCode:"",
            tmpChar:"",
            tmpInt:0
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedPub,setSelectedPub]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");

    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    const setGroupName=(e: InputChangeEvent|string)=>{
        if (typeof(e)=="string"){
            setNewGroupPub({...newGroupPub, name: (e as string) || ''})
        }else{
            setNewGroupPub({...newGroupPub, name: (e.target.value as string) || ''})
        }        
    }

    const setUserType=(e: InputChangeEvent)=>{
        setNewGroupPub({...newGroupPub, userType: (e.value)})
    }

    const setGroupNum=(e: InputChangeEvent)=>{
        console.log(e.value);
        setNewGroupPub({...newGroupPub, groupNum: (e.value)})
    }

    const setGroupCode=(e:InputChangeEvent)=>{
        console.log(e.value);

        setNewGroupPub({...newGroupPub, groupNumCode: (e.value)})
    }

    const setPub=(pub:string[])=>{
        console.log(pub);
        
        //setSelectedPub(e.value);
        setNewGroupPub({...newGroupPub, pubNum: pub[0].toString()})
    }
    



    const validateGroupPub= async()=>{
        var pubValid={
            pubNum:false,
            name:false,
            userType:false
        }
        if (Number(newGroupPub.pubNum)>-1){
            pubValid.pubNum=true;
        }
        if (newGroupPub.name!==""){
            pubValid.name=true;            
        }
        if (newGroupPub.userType!==""){
            pubValid.userType=true;
        }
        return pubValid;
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisPub=()=>{
        if (props.action=="Edit"){
            const pubNum = newGroupPub.pubNum;
            const groupName = newGroupPub.name;
            const userType = newGroupPub.userType
            if (groupName!="" && Number(pubNum)>-1){
               deleteGroupPub(pubNum.toString(),groupName,userType);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisPub= async ()=>{

        var oPubNum;
        var oName;
        var oUserType;
        console.log(newGroupPub);
        validateGroupPub().then((pubValid)=>{
             if (pubValid.name===true && pubValid.pubNum===true && pubValid.userType===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oPubNum=props.groupPub.pubNum;
                    oName = props.groupPub.name;
                    oUserType=props.groupPub.userType
                 }else{
                     //create new pub
                    oPubNum=-1;
                    oName = "";
                    oUserType=""
                 }
                 var formData:upGroupPubListEntry = {
                    oPubNum:(oPubNum !== undefined ? oPubNum : -1).toString(),
                    oName:oName,
                    oUserType:oUserType,
                    name:newGroupPub.name,
                    pubNum:newGroupPub.pubNum.toString(),
                    userType:newGroupPub.userType,
                    groupNum:newGroupPub.groupNum.toString(),
                    groupNumCode:newGroupPub.groupNumCode,
                    tmpChar:newGroupPub.tmpChar,
                    tmpInt:newGroupPub.tmpInt
                };
                 console.log(formData);
                 saveGroupPub(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }

    useEffect(()=>{
        console.log(newGroupPub);
    },[newGroupPub])

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.groupPub); 
        if (props.groupPub){
            setNewGroupPub({
            oName:"",
            oPubNum:"",
            name:props.groupPub.name,
            pubNum:props.groupPub.pubNum?.toString()||"",
            userType:props.groupPub.userType,
            groupNum:props.groupPub.groupNum,
            groupNumCode:props.groupPub.groupNumCode,
            tmpChar:props.groupPub.tmpChar,
            tmpInt:props.groupPub.tmpInt
        })
            
            //setNewPub(props.pub);
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"50vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Group Publication Entry' message='This will permanently delete the selected group publication entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisPub}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Group Name:</Label></Col>
                <Col xs="9"><Input value={newGroupPub.name} onChange={setGroupName} maxLength={50} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Publication:</Label></Col>
                <Col xs="9"><PubList setReturnAction={setPub} value={newGroupPub.pubNum!==""?[newGroupPub.pubNum.toString()]:[]} type="Single" archiveOnly={false} liveOnly={false} siteFilter='' className='' returnField='num' onlineOnly={false} printOnly={false} same={false}></PubList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>User Type:</Label></Col>
                <Col xs="9"><Input value={newGroupPub.userType} onChange={setUserType} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Group Number:</Label></Col>
                <Col xs="9"><Input value={newGroupPub.groupNum} onChange={setGroupNum}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Group Code:</Label></Col>
                <Col xs="9"><Input value={newGroupPub.groupNumCode} onChange={setGroupCode} maxLength={150}></Input></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisPub}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminGroupPubs (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [pubs, setPubs] = useState([]);
    const [pubSelected, setPubSelected]=useState<GroupPubListEntry>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(pubs,dataState));
    //const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const setSelectedPub=(pub:GroupPubListEntry)=>{
        setPubSelected(pub);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getPubs();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Group Publication");
        setSelectedPub( {
            name:"",
            pubName:"",
            pubNum:undefined,
            userType:"",
            groupNum:"",
            groupNumCode:"",
            tmpChar:"",
            tmpInt:0
        })
        setShowEditDialog(true);
    }



    const getPubs=()=>{
        getGroupPubList().then(data=>{
            setPubs(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(pubs, e.dataState));
    };

    const processedData=process(pubs,dataState);


    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const pub:GroupPubListEntry=event.startDataItem;
        setSelectedPub(pub);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "pubNum"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        if (pubSelected){
            setTitle("Publication Configuration for: " + pubSelected?.name + " (" + pubSelected?.pubNum + ")");
            setShowEditDialog(true);
        }
    },[pubSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getPubs();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Group Publication Management</h2>
            <Toolbar>
                <Button title="New Group Publication" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Group
                </Button>       
            </Toolbar>
            <Grid
                data={processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='uid'
                id="pubGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                //onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                //skip={page.skip}
                //take={page.take}
                //total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='name' title='Group Name' width={200} />
                <GridColumn field='pubName' title='Pub Name'/>
                <GridColumn field='pubNum' title='Pub Num'/>
                <GridColumn field='userType' title='User Type'/>
                <GridColumn field='groupNum' title='Group Num'/>
                <GridColumn field='groupNumCode' title='Group Num Code'/>
                <GridColumn field='name' title='Group Name' width={200} />

            </Grid>
            {showEditDialog?
                <EditDialog title={title} groupPub={pubSelected as GroupPubListEntry} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}